export enum BranchStatus {
  PENDING = 1,
  INCOMPLETE = 2,
  APPROVED = 3,
  REJECTED = 4,
}
